export default (state = {}, {coach}: any) => {
  return {
    ...state,
    userId: coach.id,
  };
};
